<template>
	<div>
		<base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>
		<div class="container-fluid mt--7">
		<div class="row">
			<div class="col-md-12" v-if="user.dashboardUrl">
				<iframe src="https://datastudio.google.com/embed/reporting/1KT6oKPrJf5wLl0y_VXM1BQ9jJJE5GNAp/page/BvjUB" frameborder="0" style="border:0; width: 100%; height: calc(100vh - 200px);" allowfullscreen></iframe>
			</div>
		</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			apiKey: false
		};
	},
	computed: {
		user () {
			return this.$store.getters["auth/user"];
		}
	}
};
</script>
<style></style>
